/* SVALA by LINTEL PDP: native colour/size fallback (hidden once Kaching renders), delivery dates, quote slider,
   before/after slider, size guide, SVALA cart drawer after any add, lazy loops */
(function () {
  var form = document.querySelector('form[data-sva-add]');
  var nat = document.querySelector('[data-sva-native]');
  var vj = document.querySelector('[data-sva-variants]');
  var V = vj ? JSON.parse(vj.textContent) : [];
  var sel = { 1: null, 2: null };
  function cur() { var inp = form && form.querySelector('input[name=id]'); var id = inp ? Number(inp.value) : 0; return V.filter(function (x) { return x.id === id; })[0] || V[0]; }
  if (V.length) { var c0 = cur(); sel[1] = c0.o1; sel[2] = c0.o2; }
  function jump(col) { var th = document.querySelector('.oak-gal__thumbs button[data-sva-col="' + col + '"]'); if (th) th.click(); }
  function apply(fromLoad) {
    var hit = V.filter(function (x) { return x.o1 === sel[1] && x.o2 === sel[2]; })[0]; if (!hit) return;
    var inp = form && form.querySelector('input[name=id]');
    if (inp && inp.value !== String(hit.id)) { inp.value = hit.id; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    var n = document.querySelector('[data-sva-now]'), w = document.querySelector('[data-sva-was]');
    if (n) n.textContent = hit.p; if (w) w.textContent = hit.c;
    var cn = document.querySelector('[data-sva-cname]'), sn = document.querySelector('[data-sva-sname]');
    if (cn) cn.textContent = hit.o1; if (sn) sn.textContent = hit.o2;
    if (!fromLoad) {
      try { var u = new URL(location.href); u.searchParams.set('variant', hit.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variantId: hit.id } }));
    }
  }
  document.querySelectorAll('[data-sva-opt]').forEach(function (box) {
    var k = box.getAttribute('data-sva-opt');
    box.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        box.querySelectorAll('button').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        sel[k] = b.getAttribute('data-val'); apply(false); if (k === '1') jump(sel[1]);
      });
    });
  });
  /* Kaching renders its own colour/size pickers per pair; hide the fallback once it is on the page */
  if (nat) {
    var tries = 0, t = setInterval(function () {
      tries++;
      if (document.querySelector('kaching-bundles-block, kaching-bundle, [class*="kaching-bundles"]')) { nat.classList.add('is-hidden'); var pr = document.querySelector('.sva-price'); if (pr) pr.style.display = 'none'; clearInterval(t); }
      if (tries > 40) clearInterval(t);
    }, 250);
  }

  /* delivery dates */
  var M = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function addWork(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() % 6) n--; } return x; }
  function fmt(x) { return x.getDate() + ' ' + M[x.getMonth()]; }
  document.querySelectorAll('[data-sva-track] [data-d]').forEach(function (s) {
    var r = s.getAttribute('data-d').split('-').map(Number), now = new Date();
    s.textContent = r.length === 1 ? fmt(now) : fmt(addWork(now, r[0])) + ' - ' + fmt(addWork(now, r[1]));
  });

  /* quote slider */
  var qs = document.querySelector('[data-sva-qs]');
  if (qs) {
    var fs = qs.querySelectorAll('figure'), ds = qs.querySelectorAll('.sva-qs__dots span'), qi = 0;
    setInterval(function () { qi = (qi + 1) % fs.length; fs.forEach(function (f, k) { f.classList.toggle('is-on', k === qi); }); ds.forEach(function (f, k) { f.classList.toggle('is-on', k === qi); }); }, 4000);
  }

  /* before / after */
  document.querySelectorAll('[data-sva-ba]').forEach(function (ba) {
    var r = ba.querySelector('input'), b = ba.querySelector('.sva-ba__b'), h = ba.querySelector('.sva-ba__h');
    function set() { b.style.clipPath = 'inset(0 ' + (100 - r.value) + '% 0 0)'; h.style.left = r.value + '%'; }
    r.addEventListener('input', set); set();
  });

  /* size guide */
  var modal = document.querySelector('[data-sva-modal]');
  document.querySelectorAll('[data-sva-size]').forEach(function (b) { b.addEventListener('click', function () { if (modal) modal.classList.toggle('is-open'); }); });

  /* open the SVALA cart drawer (sva-shop.js) after any successful add, Kaching or native */
  var pending = false;
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (r) { if (r && r.ok && !pending) { pending = true; setTimeout(function () { pending = false; if (window.SVA) window.SVA.openCart(); }, 250); } }).catch(function () {});
      }
      return p;
    };
  }
  if (form) {
    form.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]'); btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('add'); btn.disabled = false; })
        .catch(function () { btn.disabled = false; form.submit(); });
    });
  }

  var vids = document.querySelectorAll('[data-sva-loop]');
  if (vids.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) e.target.play().catch(function () {}); else e.target.pause(); }); }, { threshold: 0.4 });
    vids.forEach(function (v) { io.observe(v); });
  }
})();

/* ===== 10-02 (Edvin): Add to cart NEVER goes to /cart - every add (theme ATC, Kaching ATC, any /cart/add form) opens the SVA brand cart drawer ===== */
(function () {
  if (window.__sva_atc) return; window.__sva_atc = 1;
  function open() { if (window.SVA && window.SVA.openCart) return window.SVA.openCart(); if (window.__lntOpen) return window.__lntOpen(); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    var b = f.querySelector('[type=submit]'); if (b) b.disabled = true;
    var fd = new FormData(f), tries = 0;
    (function add() {
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) {
          if (r.ok) { if (b) b.disabled = false; return open(); }
          if (r.status === 422) return r.json().then(function (j) { if (b) b.disabled = false; open(); if (j && j.description) alert(j.description); });
          throw new Error('add ' + r.status);
        })
        .catch(function () { if (++tries < 2) return setTimeout(add, 800); /* 10-06: bot check (429) or network -> normal form POST, back to this page (?opencart=1), drawer opens. Never /cart, never an alert */ try { var u = new URL(location.href); u.searchParams.set('opencart', '1'); var h = document.createElement('input'); h.type = 'hidden'; h.name = 'return_to'; h.value = u.pathname + u.search; f.appendChild(h); } catch (x) {} HTMLFormElement.prototype.submit.call(f); });
    })();
  }, false);
})();

/* 10-06: back from the fallback POST (?opencart=1) -> open the brand cart drawer and clean the URL */
(function () {
  try { var u = new URL(location.href); if (u.searchParams.get('opencart') !== '1') return; u.searchParams.delete('opencart'); history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (e) { return; }
  var n = 0, t = setInterval(function () { var ok = false; for (var k in window) { if (/^[A-Z]{2,4}$/.test(k) && window[k] && typeof window[k].openCart === 'function') { window[k].openCart(); ok = true; break; } } if (!ok && window.__lntOpen) { window.__lntOpen(); ok = true; } if (ok || ++n > 40) clearInterval(t); }, 150);
})();
